// Import Packages
import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';

// Import Material UI
import Tab from '@material-ui/core/Tab';
import { FormControl, MenuItem, Select, IconButton, Tabs, Menu, TextField, Button } from '@material-ui/core';
import Circle from '@material-ui/icons/FiberManualRecord';
import Close from '@material-ui/icons/Close';
import AddIcon from "@material-ui/icons/Add";
import { Autocomplete } from "@material-ui/lab";
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import Collaps from '@material-ui/icons/ExpandMore';
import { makeStyles, withStyles } from '@material-ui/styles';

// Import Pages
import { NewStyledTabs, StyledTabs } from '../../../../../../components/FlowConfigurationInputs';
import Info from '../../shortCutSection/Info';

// Import Icons
import OpenTabIcon from '../../../../../../assets/icons/headerIcons/open-tab-icon.svg'

// Import CSS
import './DetailTabs.css';
import Search from '../../../../../../components/Search/Search';

const useStyles = makeStyles((theme) => ({
    stickyAutocomplete: {
        position: 'sticky',
        top: 0,
        backgroundColor: 'white',
        zIndex: 1,
    },
}));

const StyledMenu = withStyles({
    paper: {
        border: '1px solid #d3d4d5',
        padding: "10px 10px 20px 10px",
        marginTop: "10px",
        marginLeft: "135px",
        display: "flex",
        justifyContent: "start",
        flexDirection: "column",
        width: "235px",
        height: "300px",
        borderRadius: "4px"
    },
})((props) => (
    <Menu
        elevation={0}
        getContentAnchorEl={null}
        anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'left',
        }}
        transformOrigin={{
            vertical: 'top',
            horizontal: 'right',
        }}
        {...props}
    />
));

const DetailTabs = ({ automName, tabFilter, setTabFilter, detailTabs, setDetailTabs, findAndOpenTabDialog }) => {
    const [errorHandlingTabs, setErrorHandlingTabs] = useState([])
    const [searchErrorHandlingTabs, setSearchErrorHandlingTabs] = useState([])
    const [selectedErrorHandlingTab, setSelectedErrorHandlingTab] = useState({})
    const classes = useStyles();
    const [anchorEl, setAnchorEl] = useState(null);
    const divRef = useRef(null);
    const { t } = useTranslation();

    let tabCount = 8;
    const handleChange = (event, newValue) => {
        if (event?.target?.classList) {
            const classList = Object.values(event.target.classList)
            if (classList?.length && classList.includes("show-error-handling-tabs-icon")) {
                return
            }
        }
        setTabFilter(newValue);
    };

    useEffect(() => {
        if (detailTabs) {
            const newDetailTabs = JSON.parse(JSON.stringify(detailTabs))
            const eHTabs = newDetailTabs.filter((tab) => tab.errorHandling)
            const findedEhTab = eHTabs.find((tab) => tab.id === tabFilter)
            if (eHTabs.length) {
                setErrorHandlingTabs(eHTabs)
                setSearchErrorHandlingTabs(eHTabs)
            }
            else {
                setErrorHandlingTabs([])
            }
            if (findedEhTab) {
                setSelectedErrorHandlingTab(findedEhTab)
            }
            else if (tabFilter === 0) {
                setSelectedErrorHandlingTab({})
            }
        }
    }, [detailTabs, tabFilter])

    useEffect(() => {
        function handleClickOutside(event) {
            if (divRef.current && !divRef.current.contains(event.target)) {
                setAnchorEl(false);
            }
        }

        document.addEventListener('mousedown', handleClickOutside);

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [divRef]);

    useEffect(() => {
        const newDetailTabs = JSON.parse(JSON.stringify(detailTabs))
        const eHTabs = newDetailTabs.filter((tab) => tab.errorHandling)
        if (detailTabs.length === eHTabs.length) {
            const removeScrolls = setInterval(() => {
                const scrolls = document.querySelectorAll(".new-flow-tab-container .MuiTabs-scrollButtons")
                if (scrolls.length) {
                    scrolls[0].style.display = "none"
                    scrolls[1].style.display = "none"
                    clearInterval(removeScrolls)
                }
            }, 300);
            setTimeout(() => {
                clearInterval(removeScrolls)
            }, 2000);
        }
        else {
            const scrolls = document.querySelector(".new-flow-tab-container .MuiTabs-scrollButtons")
            if (scrolls) {
                scrolls.style.display = "inline-flex"
            }
        }
    }, [selectedErrorHandlingTab, detailTabs]);


    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleClick = (event) => {
        setAnchorEl((pre) => !pre);
    };


    const handleTabClose = (e, index) => {
        e.stopPropagation();
        const filteredTabs = detailTabs.filter((tab) => tab.id !== index)
        // detailTabs.splice(index, 1);
        // if (index + 1 === tabFilter) setTabFilter(index);
        if (index === tabFilter) setTabFilter(0);
        // if (detailTabs.length === 1) setTabFilter(0);
        setDetailTabs([...filteredTabs]);
    }

    return (
        <div className="new-flow-tabs">
            <img src={OpenTabIcon} />
            <NewStyledTabs className='new-flow-tab-container' value={tabFilter}>
                {/* <StyledTabs classes={} value={tabFilter}> */}
                {/* <Tab className='tab-button-container' onClick={(e) => handleChange(e, 0)} value={0} label={
                    <Info value={automName}>
                        <span className='content-overflow tab-name-area main-tab-button'>
                            {t("MESSAGES.AUTOMS.MAIN-FLOW")}
                        </span>
                    </Info>
                } /> */}
                {!selectedErrorHandlingTab.id ?
                    <Tab className='tab-button-container group-tab-button-container' onClick={(e) => handleChange(e, 0)} value={0} label={
                        <Info value={automName}>
                            <div className="detailtab-label">
                                <span className='content-overflow tab-name-area'>
                                    {t("MESSAGES.AUTOMS.MAIN-AUTOM")}
                                </span>
                                {errorHandlingTabs.length ? anchorEl
                                    ? <ExpandLessIcon className='show-error-handling-tabs-icon' onClick={handleClick} />
                                    : <ExpandMoreIcon className='show-error-handling-tabs-icon' onClick={handleClick} /> : ""}
                            </div>
                        </Info>
                    } />
                    : <Tab className='tab-button-container group-tab-button-container'
                        onClick={(e) => handleChange(e, selectedErrorHandlingTab.id)} value={selectedErrorHandlingTab.id} label={
                            <Info value={selectedErrorHandlingTab.name}>
                                <div className="detailtab-label">
                                    <span className='content-overflow tab-name-area' style={{ color: "#4F6E90" }}>
                                        {selectedErrorHandlingTab.name}
                                    </span>
                                    {errorHandlingTabs.length > 1 ? anchorEl
                                        ? <ExpandLessIcon className='show-error-handling-tabs-icon' onClick={handleClick} />
                                        : <ExpandMoreIcon className='show-error-handling-tabs-icon' onClick={handleClick} /> : ""}
                                </div>
                            </Info>
                        } />
                }
                {/* <div className='tab-seperator'></div> */}
                {detailTabs.length && detailTabs?.map((tab, index) => {
                    return !tab.errorHandling ? <Tab className='tab-button-container group-tab-button-container' onClick={(e) => handleChange(e, tab.id)} key={index} value={tab.id} label={
                        <div className="detailtab-label" >
                            <Circle
                                style={{ fontSize: 10, color: tab.color }} />
                            {/* <span className='tab-name-area' style={tab.errorHandling ? { color: "#FFFF" } : {}}>{tab.name}</span> */}
                            <span className='content-overflow tab-name-area' style={{ color: `${tabFilter === tab.id ? "#4F6E90" : "#8C90A2"}` }}>{tab.name}</span>
                            <IconButton size='small' onClick={e => handleTabClose(e, tab.id)}
                                style={{
                                    // position: 'absolute',
                                    minWidth: 20,
                                    // marginTop: -5,
                                    right: 0,
                                    backgroundColor: `#FFFF`
                                }}>
                                <Close fontSize='small' style={{ fontSize: 15 }} />
                            </IconButton>
                        </div>} /> : ""
                }
                )}
                {/* {detailTabs?.length > tabCount &&
                    <FormControl>
                        <Select value={tabFilter}>
                            {detailTabs?.slice(tabCount, detailTabs.length).map((tab, index) => (
                                <MenuItem onClick={e => handleChange(e, tab.id)} key={index} value={index + tabCount + 1}>{tab.name}</MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                } */}
            </NewStyledTabs>
            <AddIcon onClick={() => findAndOpenTabDialog()} className='header-add-group-button' />
            {/* </StyledTabs> */}
            <div
                id="simple-tab-menu"
                ref={divRef}
                style={{ display: `${anchorEl ? "flex" : "none"}` }}
            >
                <div className={classes.stickyAutocomplete}>
                    {/* <Autocomplete
                        options={errorHandlingTabs}
                        getOptionLabel={(option) => option.name}
                        value={selectedOption}
                        onChange={(event, newValue) => {
                            setSelectedOption(newValue)
                        }}
                        renderInput={(params) => <TextField {...params} label="Search" variant="outlined" />}
                    /> */}
                    <Search data={errorHandlingTabs} setSearchData={setSearchErrorHandlingTabs} customClasses={["tabs-search-input"]}
                        searchKey={['name']}></Search>
                </div>
                <div className='error-handling-tabs-container'>
                    {searchErrorHandlingTabs.map((option, index) => (
                        <MenuItem className='error-handling-tab-container' key={index} onClick={(e) => {
                            handleClose()
                            handleChange(e, option.id)
                        }}>
                            <div style={{ backgroundColor: `${option.color}` }} className='error-handling-tab-icon'><span>E</span></div>
                            <span className='content-overflow error-handling-tab-name'>
                                {option.name}
                            </span>
                        </MenuItem>
                    ))}
                </div>
            </div>
            {/* <StyledMenu
                id="simple-menu"
                anchorEl={anchorEl}
                keepMounted
                open={Boolean(anchorEl)}
                onClose={handleClose}
            >
                <div className={classes.stickyAutocomplete}>
                    <Autocomplete
                        options={errorHandlingTabs}
                        getOptionLabel={(option) => option.name}
                        value={selectedOption}
                        onChange={(event, newValue) => {
                            setSelectedOption(newValue)
                        }}
                        renderInput={(params) => <TextField {...params} label="Search" variant="outlined" />}
                    />
                </div>
                {errorHandlingTabs.map((option, index) => (
                    <MenuItem key={index} onClick={(e) => {
                        handleClose()
                        handleChange(e, option.id)
                    }}>
                        {option.name}
                    </MenuItem>
                ))}
            </StyledMenu> */}
            {
                selectedErrorHandlingTab.id ?
                    <Button className='back-to-main-flow-button' onClick={(e) => handleChange(e, 0)}>
                        {t("MESSAGES.AUTOMS.BACK-MAIN-AUTOM")}
                    </Button>
                    : ""
            }
        </div>
    )
}
export default DetailTabs;
